module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('code-editor'), _c('svg', {
    staticClass: "viewTask",
    attrs: {
      "viewBox": "0 0 32 32"
    },
    on: {
      "click": function($event) {
        _vm.task = !_vm.task
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.42 28.678l-12.433-12.238 6.168-6.071 6.265 6.167 13.426-13.214 6.168 6.071-19.594 19.285zM3.372 16.441l9.048 8.905 16.208-15.953-2.782-2.739-13.426 13.214-6.265-6.167-2.782 2.739z"
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.task),
      expression: "task"
    }],
    staticClass: "tasks"
  }, [_c('div', {
    staticClass: "task-overlay",
    on: {
      "click": function($event) {
        _vm.task = !_vm.task
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "cursor": "pointer"
    }
  }, [_vm._v("["), _c('span', {
    on: {
      "click": function($event) {
        _vm.toEnglish()
      }
    }
  }, [_vm._v("EN")]), _vm._v(" / "), _c('span', {
    on: {
      "click": function($event) {
        _vm.toThai()
      }
    }
  }, [_vm._v("TH")]), _vm._v("]")]), _vm._l((_vm.tasks), function(t, i) {
    return _c('div', {
      staticClass: "task",
      class: {
        'active': _vm.taskId === i
      },
      on: {
        "click": function($event) {
          _vm.taskId = i
        }
      }
    }, [_c('div', {
      staticClass: "task-title"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 32 32"
      }
    }, [_c('path', {
      attrs: {
        "d": "M30.5 24h-0.5v-6.5c0-1.93-1.57-3.5-3.5-3.5h-8.5v-4h0.5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h0.5v4h-8.5c-1.93 0-3.5 1.57-3.5 3.5v6.5h-0.5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5h-0.5v-6h8v6h-0.5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5h-0.5v-6h8v6h-0.5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5zM6 30h-4v-4h4v4zM18 30h-4v-4h4v4zM14 8v-4h4v4h-4zM30 30h-4v-4h4v4z"
      }
    })]), _c('b', [_vm._v("Task " + _vm._s(i + 1) + " - " + _vm._s(t.title))])]), (i === _vm.taskId) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(t.text)
      }
    }) : _vm._e()])
  })], 2)]), _c('div', {
    ref: "gameview",
    staticClass: "game"
  }, [(!_vm.game) ? _c('div', {
    staticClass: "blank"
  }, [_vm._m(0)]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('h1', [_vm._v("Let's Get Started!")]), _c('p', [_vm._v("You just have to "), _c('b', [_vm._v("write the code")]), _vm._v("! "), _c('br'), _vm._v("\nFeel free to experiment as your project goes.")]), _c('p', [_vm._v("Begin by completing tasks, which can be accessed "), _c('br'), _vm._v("\nusing the "), _c('b', [_vm._v("Task")]), _vm._v(" button on the lower left.")]), _c('p', [_vm._v("If you want to try out your masterpiece, "), _c('br'), _vm._v("\njust hit that "), _c('b', [_vm._v("Run Code")]), _vm._v(" button on the right.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5315dd19"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 86
// module chunks = 2